import * as React from 'react'
import { List } from "immutable"
import 'intersection-observer'
import { Action, IOWidget, mk_widget, AsyncState, async } from 'widgets-for-react'
import { CMSState, Link } from '../../../../cms/blocks/types.gen'
import { link } from '../../../../cms/blocks/utils.gen'
import { ExtraImages } from '../../../utils/extra_images.mod'
import { PublicSite_CustomPageData } from '../../../application.mod'
import { PublicSiteState } from '../../../../../public_site.main.mod'

//
import { ParsedNodeStory } from '../../../../drupal/types_and_parser/types'
import { PaginatedItem } from '../../../../drupal/types_and_parser/extra_types.mod'

import { Link as ReactRouterLink } from 'react-router-dom'
import * as moment from 'moment'
import { getLangFromUrl } from '../../../utils/history.mod'

export type PressReleaseItem = {
  title: string // "Refresco delivers robust Q2 2020 results",
  description: string // "<p><strong>Refresco delivers robust Q2 2020 results</strong></p>",
  published_at: string // "Thu, 13 Aug 2020 06:30 GMT",
  subject: string
  xml_link: string // "https://www.globenewswire.com/HexMLItem/Content/FullText/Attachments/All/Identifier/2077636/language/en",
  id: string // "2077636",
  category: string // "7125",
  text: null
}

export type pressReleasesBlockProps = {
  blockIndex: number
  item_limit?: number
  show_year_filter?: boolean
  button?: Link
  press_releases: AsyncState<PaginatedItem<PressReleaseItem>>
}

export type pressReleasesBlockStyle = Partial<{
  block_classname: string
  inview_classname: string
  inner_classname: string
  content_classname: string
  footer_classname: string
  clickable_classname: string
  visual_classname: string
}>

export function pressReleasesBlock<customBlockData>(
  props: pressReleasesBlockProps,
  options?: { style: pressReleasesBlockStyle; key?: string }
): (
    s: CMSState<customBlockData, ExtraImages, PublicSite_CustomPageData>
  ) => IOWidget<PublicSiteState, Action<CMSState<customBlockData, ExtraImages, PublicSite_CustomPageData>>> {
  return (s: CMSState<customBlockData, ExtraImages, PublicSite_CustomPageData>) => (public_state: PublicSiteState) =>
    mk_widget({
      run: (setState) => {
        return (
          <section className="block block--releases">
            <div className="block__inner container container--m grid--block">
              <header className="block__header">
                <h2 className="block__title title--l">Latest news</h2>
              </header>

              <div className="block__content">
                {async()(props.press_releases).run((a) => {
                  setState((s0) => {
                    // let block = s0.blocks.get(props.block_index) as storiesBlockData
                    let block = s0.blocks.get(props.blockIndex) as any
                    block.value.fst.press_releases = a(block.value.fst.press_releases) as AsyncState<
                      PaginatedItem<ParsedNodeStory>
                    >
                    return { ...s0, blocks: s0.blocks.set(props.blockIndex, block) }
                  })
                })}
                {props.press_releases.kind == 'loaded' ? (
                  <PressReleasesGrid
                    items={props.press_releases.value.items}
                    item_limit={props.item_limit}
                    show_year_filter={props.show_year_filter}
                  />
                ) : (
                  <div className="loader">
                    <div className="loader__inner"></div>
                  </div>
                )}
              </div>
              {props.button && (
                <footer className="block__footer container container--m grid--gutter">
                  {link(props.button, { classname: 'button button--primary' }, props.button.title)}
                </footer>
              )}
            </div>
          </section>
        )
      }
    })
}

type PressReleasesGridProps = {
  items: Immutable.List<PressReleaseItem>
  item_limit?: number
  show_year_filter?: boolean
}
type PressReleasesGridState = {
  year: number
}

class PressReleasesGrid extends React.Component<PressReleasesGridProps, PressReleasesGridState> {
  years = [2025, 2024, 2023, 2022, 2021, 2020, 2019, 2018, 2017, 2016, 2015]

  constructor(props: PressReleasesGridProps) {
    super(props)

    this.state = {
      year: this.years[0]
    }
  }

  render() {
    let items = Array.isArray(this.props.items) ? List(this.props.items) : this.props.items

    let press_releases = this.props.show_year_filter
      ? items
        .slice(0, this.props.item_limit ? this.props.item_limit : items.toArray().length)
        .filter((press_release) => moment(press_release.published_at).year() == this.state.year)
      : items
        .sort((a, b) => moment(b.published_at).unix() - moment(a.published_at).unix())
        .slice(0, this.props.item_limit ? this.props.item_limit : items.toArray().length)
    return (
      <>
        {this.props.show_year_filter &&
          <ul className="tabs">
            {this.years.map((year) => (
              <li className={`tabs__item tab title--xs${this.state.year == year ? ' tab--active' : ''}`}>
                <button className={`tab__button`} onClick={(e) => this.setState({ year: year })}>
                  {year}
                </button>
              </li>
            ))}
          </ul>
        }
        <ul className="block__list grid">
          {press_releases.map((press_release) => {
            return (
              <li className="grid__item">
                <article className="grid__article">
                  <ReactRouterLink
                    className="grid__link"
                    to={`/${getLangFromUrl()}/press-releases/${press_release.id}`}
                  >
                    <div className="grid__content">
                      <header className="grid__header">
                        <span className="grid__label block__label label--m">
                          {moment(press_release.published_at).format('D MMMM YYYY')}
                        </span>
                        <h3 className="grid__title title--xs">{press_release.title}</h3>
                      </header>
                      <span className="grid__fauxlink link link--arrow">Read more</span>
                    </div>
                  </ReactRouterLink>
                </article>
              </li>
            )
          })}
        </ul>
      </>
    )
  }
}
